import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'
import {Paper,Grid,Switch} from '@material-ui/core'

import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise'

import callAccountsApi from '../data-provider'

import ActionCellRenderer from '../components/action-cell-renderer'
import getGridConfig from './grid-config-accounts'
import Menu from './menu'
import AccountForm from './accounts-form'

const styles = theme => ({
  paper: {
    overflowX: 'auto',
    backgroundColor : '#fff',
    padding : 10,
    margin : 'auto',
    position : 'fixed',
    top : 300,
    bottom : 20,
    left : 20,
    right : 20,
  },
})

class ManageAccounts extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = {accounts:[],account:null,showInactive:false}
  }

  componentDidMount() {
    this.getAccounts()
    this.getUsers()
  }

  getAccounts = async () => {
    let accounts = await callAccountsApi("accounts","getAccounts")
    this.setState({accounts})
  }

  getUsers = async () => {
    let users = await callAccountsApi("users","getUsers")
    this.setState({users})
  }

  actionClickHandler = (action,account) => {
    switch(action)
    {
      case "new" : return this.openForm({})
      case "edit" : return this.openForm(account)
      default: {}
    }
  }
  
  onRowDoubleClicked = row => {
    this.openForm(row.data)
  }

  openForm = account => {
    this.setState({account})
  }
  
  closeForm = () => {
    this.setState({account:null})
  }

  toggleInactive = () => {
    let showInactive = !this.state.showInactive
    this.setState({showInactive})
  }

  render() {
    const { classes } = this.props

    let columnDefs = getGridConfig(this.actionClickHandler)
    let accounts = this.state.accounts.filter(c => c.active || this.state.showInactive)
    
    return (
      <React.Fragment>
          
        <Menu page="accounts"/>

        <span style={{float:"right",color:'#fff'}}>
          <Grid component="label" container item alignItems="center" spacing={1}>
            <Grid item>Active Accounts</Grid>
            <Grid item>
              <Switch
                checked={this.state.showInactive}
                onChange={this.toggleInactive}
                color="primary"
              />
            </Grid>
            <Grid item>All Accounts</Grid>
          </Grid>
        </span>

        <Paper className={classes.paper}>
          <div className="ag-theme-alpine" style={ {width: '100%' }}>
            <AgGridReact rowData={accounts} columnDefs={columnDefs} domLayout='autoHeight' frameworkComponents={{actionCellRenderer : ActionCellRenderer}} onRowDoubleClicked={this.onRowDoubleClicked}/>
          </div>
        </Paper>

        <AccountForm open={this.state.account !== null} close={this.closeForm} account={this.state.account} users={this.state.users}/>

      </React.Fragment>
    )
  }
}

export default withRouter(withStyles(styles)(ManageAccounts))
